import { featureKey, reducers } from './store/reducers'

import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'
import { ScopeConfigurationEffects } from './store/effects/scope-configuration.effects'
import { ScopeOverviewEffects } from './store/effects/scope-overview.effect'
import { ScopePaginatedOverviewEffects } from './store/effects/scope-paginated-overview.effects'

const EFFECTS = [ScopeOverviewEffects, ScopePaginatedOverviewEffects, ScopeConfigurationEffects]

@NgModule({ imports: [StoreModule.forFeature(featureKey, reducers), EffectsModule.forFeature(EFFECTS)] })
export class ScopeOverviewNgrxModule {}
